import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from "recharts";
import "./AgeGroupChart.css";

const AgeGroupChart = ({ ageGroups, title }) => {
  const [activeIndex, setActiveIndex] = React.useState(null);

  // Transform ageGroups object into array for Recharts
  const data = Object.entries(ageGroups).map(([age, count], index) => ({
    age,
    count,
    id: index,
  }));

  const handleMouseEnter = (_, index) => {
    setActiveIndex(index);
  };

  const handleMouseLeave = () => {
    setActiveIndex(null);
  };

  const primaryColor = "#8560fc";
  const hoverColor = "#7045fb";

  // Format Y-axis ticks to show only integers
  const formatYAxis = (tickItem) => Math.floor(tickItem);

  return (
    <div className="age-group-chart">
      <h3>{title}</h3>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart
          data={data}
          margin={{ top: 20, right: 20, left: 20, bottom: 30 }}
          onMouseLeave={handleMouseLeave}
        >
          <CartesianGrid strokeDasharray="3 3" opacity={0.2} />
          <XAxis
            dataKey="age"
            tick={{ fill: "#666" }}
            tickLine={{ stroke: "#666" }}
          />
          <YAxis
            tick={{ fill: "#666" }}
            tickLine={{ stroke: "#666" }}
            tickFormatter={formatYAxis}
            allowDecimals={false}
          />
          <Tooltip
            cursor={false}
            contentStyle={{
              backgroundColor: "rgba(255, 255, 255, 0.9)",
              border: "none",
              borderRadius: "8px",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
            }}
          />
          <Bar
            dataKey="count"
            radius={[4, 4, 0, 0]}
            onMouseEnter={handleMouseEnter}
          >
            {data.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={index === activeIndex ? hoverColor : primaryColor}
                className="bar-cell"
              />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default AgeGroupChart;
